// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2D0Bc","signatureBlock":"Footer_signatureBlock__jOCiB","signature":"Footer_signature___bcS6"};